import React, { useEffect, useMemo, useState } from 'react'
import { ICompanyPanel } from '../CargarPorFormulario/InterfaceFormulario'
import { ListColumnFilter } from '../Common/list-entities/ListColumnFilter';
import { OPERATORS, TYPE_CHECKBOX, TYPES } from '../../common/list-utils';
import { DetailsListView } from '../Common/DetailsList/DetailListView';
import { t } from 'i18next';
import { Button, Icon } from '@fluentui/react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../common/constants';
import NewEmpresa from './NewEmpresa/NewEmpresa';
import ContactEmpresa from './ContactEmpresa/ContactEmpresa';
import Loading from '../Spinners/Loading';
import useUserProfiles from '../../shared/hooks/useUserProfiles';
import { Nemotecnico } from '../../system/perfiles/UserProfileSystem';
import { CollaboratorData } from '../../system/collaborators/interfaces/data-grid-collaborator';

function EmpresasView(props: ICompanyPanel) {
      const uuid = uuidv4();
      const [mode, setMode] = useState<string>("gridMode");
      const [pantalla, setPantalla] = useState<number>(0);
      const [modal, setModal] = useState<boolean>(false);
      const [empresaId, setEmpresaId] = useState<string>();
      const navigate = useNavigate();
      const [collaborators, setCollaborators ]= useState<CollaboratorData[]>([])
      const { profiles } = useUserProfiles(props.system.getUserProfileSystem());

      const urlbase = props.system.getCompanySystem().getBaseUrlForDatagridEmpresas();

      const listpais = useAsyncDataCourier(
         () => props.system.getCompanySystem().getPaises(uuid,'list-paises'),
         [props.system],
         props.courier
        );

      const listtipo = useAsyncDataCourier(
         () => props.system.getCompanySystem().getListTipo(uuid,'list-tipo'),
         [props.system],
         props.courier
      );

      useEffect(() => {
         if (profiles.length > 0) {
            (async () => {
            // Filtra solo los perfiles deseados que no sean stdUser
            const filteredProfilesIds = profiles.filter((p) => Nemotecnico.stdUser !== p.per_nemotecnico).map((p) => p.per_id);
            const data = await props.system.getCollaboratorSystem().getCollaboratorByProfiles(filteredProfilesIds, 0, 99999, false);
            setCollaborators(data.data);
            })();
         }
      }, [profiles]);


      const HandlerDetailsEmpresa = (item: any) => {
               navigate(`${routes.empresas}/${item.emp_id}`); 
      }

      const butonContacto = (item) =>{ 
            const data = item;
            return(
               <div onClick={(e)=>envclickModal(e,data)} style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                  <Icon iconName='ContactInfo' style={{color:'#0078D4',fontSize:'20px'}}/>
               </div>
      )};

      const envclickModal = (e: React.MouseEvent<HTMLDivElement, MouseEvent>,item)=>{
         e.stopPropagation();
         setEmpresaId(item.emp_id)
         setModal(true);
      }

      const quickFilters: ListColumnFilter[] = useMemo(
        ()=>[
        {
          quick:true,
          name:'emp_nro_admin_tributaria',
          type:TYPES.INPUT,
          placeholder:t('NIF(Número de identificación fiscal)'),
          operator:OPERATORS.CONTAINS
        },
        {
            quick:true,
            name:'emp_nombre',
            type:TYPES.INPUT,
            placeholder:t('Nombre'),
            operator:OPERATORS.CONTAINS
        },
        {
            quick:true,
            name:'emp_tipo',
            type:TYPES.COMBOBOX,
            placeholder:t('Tipo'),
            operator:OPERATORS.CONTAINS,
            contextForCombobox:listtipo? listtipo:[]
        },
        {
            quick:true,
            name:'pais_nombre',
            type:TYPES.COMBOBOX,
            placeholder:t('País'),
            operator:OPERATORS.CONTAINS,
            contextForCombobox: listpais? listpais:[]
        },
        {
            quick: true,
            name: 'emp_activa',
            type: TYPE_CHECKBOX,
            labelForCheckbox: t('Activo'),
            operator:  OPERATORS.CONTAINS,
        },
        {
            quick: false,
            name: 'emp_permitir_proyectos_facturables',
            type: TYPE_CHECKBOX,
            labelForCheckbox: t('Facturable'),
            operator:  OPERATORS.CONTAINS,
        },
        {
            quick: false,
            name: 'emd_fecha_inicio',
            type: TYPES.DATE,
            placeholder: t('Fecha de registro desde'),
            operator: OPERATORS.AFTERORON,
        },
        {
            quick: false,
            name: 'emd_fecha_fin',
            type: TYPES.DATE,
            placeholder: t('Fecha de baja desde'),
            operator:  OPERATORS.BEFOREORON,
        },
        {
          quick: true,
          name: 'emp_responsable_colid',
          type: TYPES.COMBOBOX_USER,
          placeholder: t('Responsable'),
          operator: OPERATORS.CONTAINS,
          contextForCombobox: collaborators.map((col) => ({key: col.col_id, text: `${col.col_nombre} ${col.col_apellido}`}))
        },
      ],[listpais,listtipo, collaborators]);

      const columns = [
         {
           fieldName:'emp_nro_admin_tributaria',
           name: t('NIF'),
         },
         {
            fieldName:'emp_nombre',
            name: t('Nombre'),
         },
         {
            fieldName:'emp_tipo',
            name: t('Tipo'),
         },
         {
            fielName:'emp_permitir_proyectos_facturables',
            name: t('Facturable'),
            _onRender: (item: any) => item.emp_permitir_proyectos_facturables == 1 ? "Si ":"No" ,
         },
         {
            fieldName:'emp_paisid',
            name: t('País'),
         },
         {
            fieldName:'emp_depto',
            name: t('Ciudad'),
         },
         {
            fieldName:'emp_distrito',
            name: t('Distrito'),
         },
         {
            fielName:'emp_direccion',
            name: t('Dirección'),
         },
         {
            fieldName:'emp_activa',
            name: t('Estado'),
            _onRender: (item: any) => item.emp_activa == 1 ? "Activa ":"Inactiva" ,
         },
         {
            fieldName:'emd_fecha_inicio',
            name: t('Fecha de registro'),
            minWidth: 80,maxWidth: 150,
         },
         {
            fieldName:'emd_fecha_fin',
            name: t('Fecha de baja'),
            minWidth: 80,maxWidth: 150,
         },
         {
            fieldName:'emp_responsable_colid',
            name: t('Responsable'),
            minWidth: 80,maxWidth: 150,
         },
         {
            fieldName:'rubros',
            name: t('Rubros'),
            minWidth: 100,maxWidth: 250,
            _onRender: (item: any) => {
               if (!item.rubros || item.rubros.length === 0) return '';
               // Muestra los nombres de los rubros separados por coma
               const text = item.rubros.map((r: any) => r.rub_nombre).join(', ')
               return <span title={text}>{text}</span>;
            },
         },
         {
            fieldName:'contactos',
            name: t('Contactos'),
            _onRender: butonContacto,
            maxWidth: 40,
         }
      ];

      useEffect(()=>{
         setPantalla(1);
      },[listpais,listtipo])
  return (
    <>
    {
     (pantalla === 0) && <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
    }
{        
      (pantalla === 1) &&  <> <div className='collaborator_create_hader_buton'>
             <Button onClick={()=>setPantalla(2)}  
             className='collaborator_create_bt' > <Icon iconName='add' className='collaborator_create_icon'/> 
             <p> {t('Nuevo')}</p> 
             </Button>
         </div>
          <DetailsListView 
                     changeBlockUI={props.changeBlockUI}
                     keyList={'DetailsListView-empresas'}
                     onClickCardMode={() => setMode("cardMode")}
                     onClickGridMode={() => setMode("gridMode")}
                     mode={mode}
                     title={t('Empresas')}
                     cols={columns}
                     isGridList={true}
                     courier={props.courier} 
                     listFilters={[]}
                     quickFilters={quickFilters}
                     onItemClick={HandlerDetailsEmpresa}
                     baseUrl={urlbase}
         />
         </>
         }
{
         (pantalla === 2) && <NewEmpresa
                     setpantalla={setPantalla}
                     changeBlockUI={props.changeBlockUI}
                     courier={props.courier}
                     system={props.system}
                     user={props.user}
                     key={'pantalla nueva empresa'}
                     uuid={uuid}
         />
}
{ modal && <ContactEmpresa modal={modal} setModal={setModal} empresaId={empresaId} system={props.system} uuid={uuid} changeBlockUI={props.changeBlockUI} courier={props.courier} />}
    </>
  )
}

export default EmpresasView